import * as React from "react";
const EnergyEfficientSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="m41.813 25.803-2.791-5.585a1.748 1.748 0 0 0-2.348-.782l-2.72 1.36-5.73-1.517a.892.892 0 0 0-.45 0l-5.73 1.516-2.72-1.36a1.752 1.752 0 0 0-2.348.783l-2.791 5.584a1.751 1.751 0 0 0 .782 2.348l2.953 1.477 6.07 4.335c.089.064.19.11.296.137l7 1.75a.874.874 0 0 0 .831-.23l6.023-6.024 2.89-1.445a1.75 1.75 0 0 0 .782-2.347h.001Zm-6.003 3.65-3.764-3.015a.875.875 0 0 0-1.168.067c-1.948 1.962-4.12 1.714-5.504.839l4.73-4.594h3.479l2.976 5.951-.75.751ZM18.54 21l2.24 1.118-2.797 5.583-2.235-1.116L18.541 21ZM31.23 34.03l-6.356-1.588-5.381-3.844 3.062-6.125L28 21.031l1.072.283-4.922 4.777-.009.01a1.75 1.75 0 0 0 .298 2.714c2.249 1.436 4.962 1.203 7.1-.547l3.024 2.43-3.333 3.332Zm6.781-6.33-2.791-5.578L37.457 21l2.792 5.585L38.01 27.7Zm-9.597 10.136a.875.875 0 0 1-1.061.637l-4.558-1.14a.861.861 0 0 1-.297-.137l-2.881-2.058a.875.875 0 0 1 1.017-1.422l2.746 1.962 4.401 1.098a.876.876 0 0 1 .637 1.061l-.005-.001Z"
    />
  </svg>
);
export default EnergyEfficientSVG;
